import './src/fonts/font-face.css';
import { isBrowser } from './src/utils/isBrowser';

export { wrapPageElement, wrapRootElement } from './gatsby-shared';

export const onRouteUpdate = () => {
  if (isBrowser && window.mhct) {
    // Check if the mhct object exists
    window.mhct.reload();
  }
};

export const onInitialClientRender = () => {
  if (isBrowser && window.mhct) {
    // Check if the mhct object exists
    window.mhct.reload();
  }
};

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  // Handle hash links: Let Gatsby handle them smoothly.
  if (location.hash) {
    return true;
  }

  const savedPosition = getSavedScrollPosition(location);
  let performInstantScrollToTop = false;

  if (savedPosition) {
    if (savedPosition[0] === 0 && savedPosition[1] === 0) {
      performInstantScrollToTop = true;
    } else {
      return savedPosition;
    }
  } else {
    performInstantScrollToTop = true;
  }

  // If marked for instant scroll to top, execute that logic.
  if (performInstantScrollToTop) {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });

    return false;
  }

  return true;
};
